module.exports = __webpack_public_path__ + "static/media/CN.3be9bcd4.svg";